import React, { useEffect, useRef } from 'react';
import { getLabel } from '../../data/labels';
import PrematchContext from '../../contexts/PrematchContext';
import FastbetCartContext from '../../data/fastbet/FastbetCartContext';

export default function SearchBar(props) {
    const fastbetContext = React.useContext(FastbetCartContext);
    const prematchContext = React.useContext(PrematchContext);
    const ref = useRef(null);

    useEffect(() => {
        const listener = () => {
            ref.current.value = '';
        }
        window.addEventListener('reset-search', listener);
        return () => window.removeEventListener('reset-search', listener);
    }, [])

    function handleChange(event) {
        const search = event.target.value;
        if (prematchContext.section === 'event-search') {
            if (search.length === 0) {
                prematchContext.reset();
            } else {
                prematchContext.openSearch(search);
            }
        } else if (search.length > 2 || (search.length >= 2 && window.appConfig?.TERMINAL_AGENCY)) {
            prematchContext.openSearch(search);
        }
    }

    function handleFocus() {
    	if (!fastbetContext.isInitialized()) {
    		fastbetContext.initialize();
    	}
    }
    
    return (
        <>
            <input type="search" 
            		id="match-search-input" 
            		name="ricerca" 
            		placeholder={fastbetContext.isLoading()? getLabel('general.loading') : getLabel('general.ricerca') } 
            		onChange={handleChange}
            		onFocus={handleFocus}
            		readOnly={!fastbetContext.isDataLoaded()}
                    ref={ref}
            />
        </>
    );
}
